import { defineMessages } from 'react-intl';

export default defineMessages({
    newPassword: {
        id: 'auth.components.ResetPassword.Enter New Password',
        defaultMessage: 'Enter New Password'
    },
    fieldEmpty: {
        id: 'auth.components.ResetPassword.Enter your new password.',
        defaultMessage: 'Enter your new password.'
    },
    fieldIncorrect: {
        id: 'auth.components.ResetPassword.Fields password and confirmation do not match.',
        defaultMessage: 'Fields password and confirmation do not match.'
    },
    password: {
        id: 'auth.components.ResetPassword.Password:',
        defaultMessage: 'Password:'
    },
    confirmPassword: {
        id: 'auth.components.ResetPassword.Confirm Password:',
        defaultMessage: 'Confirm Password:'
    },
    backToSignIn: {
        id: 'auth.components.ResetPassword.Back to Sign In',
        defaultMessage: 'Back to Sign In'
    },
    changePassword: {
        id: 'auth.components.ResetPassword.Change Password',
        defaultMessage: 'Change Password'
    },
    passwordSuccessfullyChanged: {
        id: 'auth.components.ResetPassword.Password successfully changed',
        defaultMessage: 'Password successfully changed'
    },
    returnToSignInAndEnterNewPassword: {
        id: 'auth.components.ResetPassword.Return to Sign In and enter your new password.',
        defaultMessage: 'Return to Sign In and enter your new password.'
    },
    invalidToken: {
        id: 'auth.components.ResetPassword.Invalid token',
        defaultMessage: 'Invalid token'
    },
    resetPasswordLinkDoesntWork: {
        id: 'auth.components.ResetPassword.Sorry, your reset password link is no longer valid.',
        defaultMessage: 'Sorry, your reset password link is no longer valid.'
    },
    unableToProcessYourRequest: {
        id: 'auth.components.ResetPassword.Unable to process your request',
        defaultMessage: 'Unable to process your request'
    },
    resetPasswordLinkNotWorkingOrOldPassword: {
        id: 'auth.components.ResetPassword.Reset password link is no longer valid or your new password should not be same as old password.',
        defaultMessage: 'Reset password link is no longer valid or your new password should not be same as old password.'
    },
    invalidAttempt: {
        id: 'auth.components.ResetPassword.Invalid attempt',
        defaultMessage: 'Invalid attempt'
    },
    unableToProcessYourRequestError: {
        id: 'auth.components.ResetPassword.Unable to process your request.',
        defaultMessage: 'Unable to process your request.'
    },
    passwordRules : {
        id: "auth.components.ResetPassword.Password Rules",
        defaultMessage: "Please ensure that your password meets all of the following criteria:"
    },
    passwordRule1 : {
        id: "auth.components.ResetPassword.passwordRule1",
        defaultMessage: "At least 10 characters long"
    },
    passwordRule2 : {
        id: "auth.components.ResetPassword.passwordRule2",
        defaultMessage: "Includes at least one capital letter"
    },
    passwordRule3 : {
        id: "auth.components.ResetPassword.passwordRule3",
        defaultMessage: "Includes at least one lower case letter"
    },
    passwordRule4 : {
        id: "auth.components.ResetPassword.passwordRule4",
        defaultMessage: "Includes at least one numeric digit"
    },
    passwordRuleError : {
        id : "Password does not meet the above criteria.",
        defaultMessage: "Password does not meet the above criteria."
    },
    resetpasswordExpired : {
        id: "auth.components.ResetPassword.Password reset expired",
        defaultMessage: "Password reset expired"
    },
    passwordRule5 : {
        id: "auth.components.ResetPassword.passwordRule5",
        defaultMessage: "Your new password should not be same as old password"
    },
    passwordRule6 : {
        id: "auth.components.signup.passwordRule6",
        defaultMessage: "Includes at least one special character"
    },
	newPasswordChanged: { 
        id: "auth.components.ResetPassword.Password updated successfully!",
        defaultMessage: "Password updated successfully!"
    }
});
